import { Button } from '@mui/material';

import { ConfirmationDialog } from 'common';

export interface EndpointCardDeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
}

export function EndpointCardDeleteDialog(props: EndpointCardDeleteDialogProps) {
  const { isOpen, onClose, onRemove } = props;

  return (
    <ConfirmationDialog
      title="Remove this endpoint?"
      onClose={onClose}
      open={isOpen}
      actions={
        <>
          <Button variant="outlined" onClick={() => onClose()}>
            Nevermind
          </Button>
          <Button variant="contained" color="error" onClick={() => onRemove()}>
            Remove Endpoint
          </Button>
        </>
      }
    >
      Removing an endpoint will reset the selected Method and Path.
    </ConfirmationDialog>
  );
}
